module.exports = __webpack_public_path__ + "img/gift5.2c8a6fe3.png";